import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { StandardChip } from "../../../../../shared/components/badges/StandardChip"

const useStyles = makeStyles()((theme) => ({
    // The clickable preview placeholder until the displays can render real thumbnails.
    thumbnail: {
        position: "relative",
        aspectRatio: "16 / 10",
        width: "100%",
        padding: 0,
        border: "none",
        borderBottom: `1px solid ${theme.palette.tailwind.slate[200]}`,
        cursor: "pointer",
        background: `repeating-linear-gradient(135deg, ${theme.palette.tailwind.slate[200]} 0 .5rem, ${theme.palette.tailwind.slate[100]} .5rem 1rem)`,
    },
    label: {
        padding: ".25rem .625rem",
        borderRadius: ".375rem",
        background: theme.palette.background.paper,
        color: theme.palette.tailwind.slate[500],
    },
    statusChip: {
        position: "absolute",
        top: ".75rem",
        left: ".75rem",
        background: theme.palette.background.paper,
    },
}))

type Props = Readonly<{
    isInactive: boolean
    onPreview: () => void
}>

export function InfoDisplayThumbnail({ isInactive, onPreview }: Props) {
    const { classes } = useStyles()

    return (
        <Stack
            component="button"
            type="button"
            alignItems="center"
            justifyContent="center"
            className={classes.thumbnail}
            onClick={onPreview}
        >
            <LocalizedStrict id="merchant-info-displays-card-thumbnail-label">
                <Typography variant="caption" className={classes.label}>
                    display preview
                </Typography>
            </LocalizedStrict>
            <LocalizedStrict
                id={
                    isInactive
                        ? "merchant-info-displays-card-status-inactive"
                        : "merchant-info-displays-card-status-live"
                }
                attrs={{ label: true }}
            >
                <StandardChip
                    size="small"
                    variant={isInactive ? "grey" : "success"}
                    className={classes.statusChip}
                    label="Live"
                />
            </LocalizedStrict>
        </Stack>
    )
}
